export default {
  title: 'Loyalitetsprogram',
};
